import { Checkbox, FormControlLabel, FormGroup, Grid, Link, Typography } from '@mui/material';
import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';

import { LegalAgreements } from 'src/hooks/core-api/useLegalAgreements';
import { OnboardingStepProps } from 'src/pages/onboarding/OnboardingPage';

interface AgreementsStepProps extends OnboardingStepProps {
  agreements: LegalAgreements;
  isLoading: boolean;
}

const AgreementsStep = ({ onNextStep, agreements, isLoading }: AgreementsStepProps) => {
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    event.target.checked ? setChecked(true) : setChecked(false);
  };

  const CheckboxLabel = (
    <Typography style={{ textAlign: 'left' }}>
      <span>I agree to the </span>
      <Link href={agreements.terms_of_service} target="_blank">
        Terms of Service
      </Link>
      <span> and </span>
      <Link href={agreements.privacy_policy} target="_blank">
        Privacy Policy
      </Link>
      <span>
        &nbsp;and provide my consent to receive email marketing communication from Lovage Labs
      </span>
    </Typography>
  );

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100%' }}
    >
      <div>
        <Grid item>
          <Typography variant="h4" align="center" sx={{ mb: 6 }}>
            Agreements
          </Typography>
          <FormGroup sx={{ pl: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleChange}
                  // For some reason the checkbox keeps unchecking itself when button is clicked
                  checked={checked || isLoading}
                  sx={{ transform: 'scale(1.3)', pr: 1 }}
                />
              }
              label={CheckboxLabel}
            />
          </FormGroup>
        </Grid>
        <Grid item sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
          <LoadingButton
            variant="contained"
            size="large"
            onClick={onNextStep}
            loading={isLoading}
            disabled={!checked}
          >
            Agree
          </LoadingButton>
        </Grid>
      </div>
    </Grid>
  );
};

export default AgreementsStep;
